import type { ChannelVerifyStatus } from '@/api/channel/type'
import pagePath from '@/utils/pagePath'
import styled from '@emotion/styled'
import { Button, Flex, Text, Title } from '@collable/ui'
import { Link } from 'react-router'

interface VerifyStatusProps {
  status: ChannelVerifyStatus
}

const VerifyStatus = ({ status }: VerifyStatusProps) => {
  if (status === 'REQUESTED')
    return (
      <Container direction="column" gap={12} alignItems="center">
        <Title size="title2" fontWeight="bold" as="h2">
          승인 요청이 완료됐어요
        </Title>
        <Text size="body1" color="labelAssistive" textAlign="center">
          콜라블에서 확인 중이에요.
          <br />
          빠르게 검토해 채널 등록을 마무리할게요.
        </Text>
      </Container>
    )
  return (
    <Container direction="column" gap={40}>
      <Flex direction="column" gap={20}>
        <Flex direction="column" gap={12} alignItems="center">
          <Title size="title2" fontWeight="bold" as="h2">
            채널 등록에 실패했어요
          </Title>
          <Text size="body1" color="labelAssistive">
            콜라블 이메일 인증에 실패했어요. 다음의 경우에 등록이 불가능합니다.
          </Text>
        </Flex>
        <Description direction="column" as="ul">
          <li>유튜브 채널에 공개된 이메일 주소와 입력한 이메일이 다른 경우</li>
          <li>유튜브 채널에 이메일 정보를 확인할 수 없는 경우</li>
        </Description>
      </Flex>
      <Link to={pagePath.selectVerifyMethod}>
        <Button size="large" kind="solid" color="neutral" width="100%">
          다시 인증하기
        </Button>
      </Link>
    </Container>
  )
}

export default VerifyStatus

const Container = styled(Flex)`
  width: 600px;
  margin: 120px auto 0 auto;
  padding: 40px 60px;
  border: 1px solid ${({ theme }) => theme.line.lineNeutral};
  border-radius: 20px;
  background-color: ${({ theme }) => theme.fill.fillAssistive};
  height: fit-content;
`

const Description = styled(Flex)`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.status.statusNegative};
  background-color: ${({ theme }) => theme.common.commonWhite};

  li {
    list-style: disc;
    margin-left: 16px;
  }
`
